import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckVendors } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';

import { TCMVendorsOptions } from '@interfaces/cmModule/cmModule';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_VENDORS } from '@constants/queryKeys';

const useQueryConsistencyCheckVendors = () => {
	const {
		data: vendorsOptions,
		isLoading: isLoadingVendorsOptions,
		isFetching: isFetchingVendorsOptions,
	} = useQuery<TCMVendorsOptions[], TSelectOption[]>({
		queryKey: [CONSISTENCY_VENDORS],
		queryFn: extractQueryParams(getConsistencyCheckVendors),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		select: (options) => optionsFormattedWithAvailability(options),
		...refetchOptions,
	});

	return {
		vendorsOptions: vendorsOptions || [],
		isLoadingVendorOptions: (isLoadingVendorsOptions && !!vendorsOptions)
			|| isFetchingVendorsOptions,
	};
};

export default useQueryConsistencyCheckVendors;
